export default function DetalhesMeuVeiculo(){
    return(
        "Detalhes Meu Veiculo"
    )
}